import { BasketClient } from '@frontend/basket/api';
import { Basket, CreateBasket } from '@frontend/basket/types';
import { EntityType } from '@frontend/common';
import { Form } from '@frontend/components/forms';
import { EnumSelectListV2 } from '@frontend/components/select';
import { useFormValues } from '@frontend/repository';
import { useMemo } from 'react';

import { useAppDispatch } from '../../redux/store';
import useBasketCreate from './basket-create.controller';

const ID = 'basket-create';

const BasketCreate = () => {
    const viewProps = useBasketCreate();
    const dispatch = useAppDispatch();
    const formValues = useFormValues<CreateBasket>(ID);

    const enumOverwrite = useMemo(() => new Map<keyof CreateBasket, keyof typeof EnumSelectListV2>([['status', 'basket_status']]), []);

    return (
        <div id={ID}>
            <Form<Basket, CreateBasket>
                id={ID}
                useStaticId
                type={EntityType.IOT}
                value={{}}
                dispatch={dispatch}
                show={['spot_id']}
                required={['status']}
                submitDisabled={!viewProps.account_id || !formValues?.status}
                onCancel={viewProps.onCancel}
                onSubmit={(v) => BasketClient.postBasket(viewProps.account_id!, v)}
                onSubmitSuccess={viewProps.onSubmitSuccess}
                enumOverwrite={enumOverwrite}
            />
        </div>
    );
};

export default BasketCreate;
